import React from 'react';
import {EmptyContainer, EmptyText, EmptyTitle} from './styles';

export default () => (
  <EmptyContainer>
    <EmptyTitle>COMING SOON...</EmptyTitle>
    <EmptyText>
      With so many different ways today to find information online, it can sometimes be hard to know where to go to first. I want to look
      at the major and most effective ways to find information online.
    </EmptyText>
  </EmptyContainer>
);
